export default {
  report: `Raport`,
  startups: `100 startupów`,
  extraContent: `Materiały dodatkowe`,
  fintech: `Let’s Fintech`,
  downloadReport: `Pobierz raport`,
};
